<script setup lang="ts">
  import {useI18n} from 'vue-i18n';
  import useCpBem from '~/composables/useCpBem';
  import CpSectionHeader from '~/components/cp/CpSection/CpSectionHeader/CpSectionHeader.vue';
  import CpText from '~/components/cp/CpText/CpText.vue';
  import CpCardQnAAnswer from '~/components/cp/CpCardQnAAnswer/CpCardQnAAnswer.vue';
  import CpCardRedirectQnA from '~/components/cp/CpCardRedirectQnA/CpCardRedirectQnA.vue';
  import CpButton from '~/components/cp/CpButton/CpButton.vue';
  import {usePdp} from '~/stores';
  import {useGetProductQuestionsPDP, useGetProductAnswersCount} from '~/composables/queries/useQnA';
  import CpNuxtLink from '~/components/cp/CpNuxtLink/CpNuxtLink.vue';

  const store = usePdp();
  const {data: questionsData} = await useGetProductQuestionsPDP({articleId: store.getProductId});
  const {data: answerCountData} = await useGetProductAnswersCount({articleId: store.getProductId});
  const answerCount = computed(() => {
    return answerCountData.value?.total ?? 0;
  });

  const {b, e} = useCpBem('cp-section-pdp-qna');
  const {t} = useI18n();
</script>

<template>
    <div :class="b">
        <CpSectionHeader
            :title="t('qna')"
            type="h2"
            show-top-border
        />

        <div v-if="questionsData && questionsData.data" :class="e('content')">
            <CpText v-if="questionsData.data.length !== 0" variant="caption-regular">
                <CpText variant="caption-bold" type="neutral">
                    {{ questionsData.meta.total }}
                </CpText>
                <CpText variant="caption-regular" type="neutral">
                    {{ t('questions') }}
                </CpText>
                <CpText variant="caption-bold" type="neutral">
                    {{ answerCount }}
                </CpText>
                <CpText variant="caption-regular" type="neutral">
                    {{ t('answersAbout') }}
                </CpText>
            </CpText>
            <CpCardQnAAnswer
                v-for="question in questionsData.data?.slice(0,4)"
                :key="question.id"
                :class="e('answers')"
                :question="question"
                pdp
            />
            <CpCardRedirectQnA v-if="questionsData.data" :no-questions="questionsData.data.length === 0" />
            <CpNuxtLink
                :class="b"
                :link="store.productDetails?.questionsLink.replace('https://www.cyberpuerta.mx', '')"
            >
                <CpButton
                    v-if="questionsData.data && questionsData.data.length"
                    data-testid="see-all-questions"
                    :label="t('seeAllQuestions')"
                    kind="label"
                    color="primary"
                    hollow
                    full-width
                    type="button"
                />
            </CpNuxtLink>
        </div>
    </div>
</template>

<style scoped lang="scss">
  .cp-section-pdp-qna {
    &__content {
      padding: $cp-gutter;
      display: flex;
      flex-direction: column;
      gap: $cp-gutter;
    }

    &__nuxt-link {
      text-decoration: none;
    }
  }
</style>

<i18n locale="es-US" lang="yaml">
  qna: 'Preguntas y respuestas'
  questions: ' preguntas y '
  answersAbout: ' respuestas sobre este producto'
  seeAllQuestions: 'Ver todas las preguntas y respuestas'
</i18n>
